import { useEffect, useState } from "react"

import {
  Heading,
  IconButton,
  Radio,
  Tappable,
  UserGeneratedHtml,
} from "@trueskin-web/components"
import { arrowRightIcon } from "@trueskin-web/theme/icons/arrowRightIcon"

const PlanVariant = ({
  isSelected,
  showRadioButton = true,
  collapsedPreview,
  expandedByDefault,
  collapsedByDefault,
  labelTile,
  title,
  description,
  priceTitle,
  showCollapseButton,
  children,
  onClick,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    if (expandedByDefault) {
      setIsExpanded(() => true)
      return
    }

    if (collapsedByDefault) {
      setIsExpanded(() => false)
      return
    }

    setIsExpanded(() => isSelected)
  }, [isSelected, expandedByDefault, collapsedByDefault])

  return (
    <div
      sx={{
        border: "1px",
        borderColor: "transparent",
        borderRadius: "8px",
        position: "relative",
      }}
      className={className}
    >
      {labelTile && (
        <div
          sx={{
            position: "absolute",
            top: 0,
            right: 4,
            transform: "translateY(-50%)",
          }}
        >
          {labelTile}
        </div>
      )}

      <Tappable
        data-testid={`web-portal-plan-selection-variant-${title.toLowerCase()}`}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexWrap: ["nowrap", "wrap"],
          lineHeight: 1,
          pointerEvents: !showRadioButton ? "none" : null,
        }}
        onClick={() => {
          if (showRadioButton) {
            onClick()
          }
        }}
      >
        <Radio
          data-testid="web-portal-plan-selection-radio-btn"
          readOnly
          checked={isSelected}
          size="lsm"
          sx={{
            ...(!showRadioButton && {
              display: "none",
            }),
          }}
        />
        <Heading
          data-testid="web-portal-plan-selection-plan-title"
          as="h4"
          size={showRadioButton ? "xsm" : "sm"}
          sx={{
            ml: 2,
            fontWeight: "bold",
            flexGrow: 1,
          }}
        >
          {title}
        </Heading>
        <Heading
          data-testid="web-portal-plan-selection-plan-price"
          as="h4"
          size="sm"
          sx={{
            flexShrink: 0,
          }}
        >
          {priceTitle}
        </Heading>
      </Tappable>
      <div sx={{ display: "flex", justifyContent: "space-between" }}>
        {description && (
          <div sx={{ mt: 1 }}>
            <UserGeneratedHtml html={description} />
          </div>
        )}
        {showCollapseButton && (
          <IconButton
            icon={arrowRightIcon}
            onClick={() => setIsExpanded((value) => !value)}
            sx={{
              mt: 1,
              transform: isExpanded ? "rotate(-90deg)" : "rotate(90deg)",
              transition: "all .2s ease-in ",
            }}
          />
        )}
      </div>
      {!isExpanded && collapsedPreview && <div>{collapsedPreview}</div>}
      <div sx={{ display: isExpanded ? "block" : "none", mt: 2 }}>
        {children}
      </div>
    </div>
  )
}

export default PlanVariant
